import { useQuery } from '@apollo/client';
import { GeoSearchDocument } from '../../../../graphql/query/geo/search.generated';

export function useCountriesOptionsFetch() {
  const { data, loading } = useQuery(GeoSearchDocument, { variables: { phrase: '(type:country AND country:*)' } });

  const countries = (data?.geoSearch ?? [])
    .map(option => {
      //make all words uppercase
      const name = option.name
        .split(' ')
        .map(word => word[0].toUpperCase().concat(word.slice(1)))
        .join(' ');

      return { [option.id]: { id: option.id, name } };
    })
    .reduce((acc, curr) => {
      return Object.assign(acc, curr);
    }, {});

  return {
    countries,
    isCountriesLoading: loading,
  };
}
